/**
 * PlanBadge — Algomed tier badge.
 * Ayniyat: HomeHubPage hero'sunda kullanilan tier baddesinin Mini App muadili.
 */
import { Badge, HStack, Text } from '@chakra-ui/react';
import { BRAND, type Tier } from '@algobot/shared';

const SCHEME: Record<Tier, string> = {
  free: 'gray',
  silver: 'gray',
  gold: 'yellow',
  diamond: 'purple',
};

const LABEL: Record<Tier, string> = {
  free: 'Ücretsiz',
  silver: 'Silver',
  gold: 'Gold',
  diamond: 'Diamond',
};

export interface PlanBadgeProps {
  tier?: string | null;
  size?: 'sm' | 'md';
}

export default function PlanBadge({ tier, size = 'sm' }: PlanBadgeProps) {
  const safeTier = ((tier || 'free').toLowerCase() as Tier);
  const scheme = SCHEME[safeTier] ?? 'gray';
  const label = LABEL[safeTier] ?? safeTier.toUpperCase();
  const glyph = BRAND.emojiPlan[safeTier] || BRAND.emojiPlan.free;

  return (
    <Badge
      colorScheme={scheme}
      borderRadius="full"
      px={size === 'md' ? 2.5 : 2}
      py={size === 'md' ? 1 : 0.5}
      fontSize={size === 'md' ? 'sm' : 'xs'}
      textTransform="none"
      fontWeight="semibold"
    >
      <HStack spacing={1.5}>
        <Text as="span" fontSize={size === 'md' ? 'md' : 'sm'} lineHeight="1">{glyph}</Text>
        <Text as="span" lineHeight="1">{label}</Text>
      </HStack>
    </Badge>
  );
}
